import { ElementRef } from '@angular/core';
import { Subscription, debounceTime, fromEvent, throttleTime } from 'rxjs';
import { IDynamicHeightComponent } from '../../interfaces/common/ui/dynamic-height-component.interface';

export function syncComponentHeightResize(
  component: IDynamicHeightComponent,
  contentElement: ElementRef<HTMLDivElement>,
  containerElement: ElementRef<HTMLDivElement>
): Subscription {
  syncComponentHeight(component, contentElement, containerElement);
  return fromEvent(window, 'resize')
    .pipe(throttleTime(500), debounceTime(500))
    .subscribe(() => {
      syncComponentHeight(component, contentElement, containerElement);
    });
}

// This is a performance bottleneck
// It is being used for the sidenav to sync
// height at runtime, specifically to account for
// additional component renders to the page after initialization
export function syncComponentHeightInterval(
  component: IDynamicHeightComponent,
  contentElement: ElementRef<HTMLDivElement>,
  containerElement: ElementRef<HTMLDivElement>
): ReturnType<typeof setInterval> {
  return setInterval(() => {
    syncComponentHeight(component, contentElement, containerElement);
  }, 2000);
}

function syncComponentHeight(
  component: IDynamicHeightComponent,
  contentElement: ElementRef<HTMLDivElement>,
  containerElement: ElementRef<HTMLDivElement>
) {
  if (!contentElement || !containerElement || !component) return;
  const contentHeight = contentElement.nativeElement.offsetHeight;
  const containerHeight = containerElement.nativeElement.offsetHeight;
  if (contentHeight > containerHeight) {
    component.setHeight(contentHeight);
  } else {
    component.setHeight(containerHeight);
  }
}
